import { uaaFetchStatus } from '../../../models/auth'
import {
  bookmarkVideo,
  fetchUserActiveCourses,
  addUserActiveCourse,
  removeUserActiveCourse,
  fetchBookmarksByCourse,
  removeBookmark,
  fetchAllUserCourseProgress,
  fetchUserCourseProgress,
  addUserWatchedVideo,
  removeUserWatchedVideo,
  fetchUserLearningPathProgress,
  fetchUserLearningPathResume,
  fetchUserActiveSubscriptions,
  fetchSampleAvatars,
  postUserAvatar,
} from '../../../models/user'

const getBookmarksByCourse = async (context, userId) => {
  try {
    const response = await fetchBookmarksByCourse(userId)
    context.commit('USER_BOOKMARKS_COURSES_UPDATED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const deleteBookmarkById = async (context, id) => {
  try {
    const response = await removeBookmark(id)
    context.commit('BOOKMARK_DELETED', response)
    context.dispatch('app/setNotification', 'Bookmark deleted', {
      root: true,
    })
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const storePendingUserBookmark = (context, bookmark) => {
  context.commit('USER_PENDING_BOOKMARK', bookmark)
}

const postUserVideoBookmark = async (context, data) => {
  try {
    const response = await bookmarkVideo(data)
    context.commit('USER_POSTED_BOOKMARK', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const getUserActiveCourses = async (context, userId) => {
  try {
    const response = await fetchUserActiveCourses(userId)
    context.commit('USER_ACTIVE_COURSES_UPDATED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const getAllUserCourseProgress = async (context, userId) => {
  try {
    const response = await fetchAllUserCourseProgress(userId)
    context.commit('USER_ALL_COURSE_PROGRESS_UPDATED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const getUserCourseProgress = async (context, courseAndUserId) => {
  try {
    await uaaFetchStatus()
    const response = await fetchUserCourseProgress(courseAndUserId)
    context.commit('USER_ACTIVE_COURSE_PROGRESS_UPDATED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const postToUserActiveCourse = async (context, data) => {
  try {
    const response = await addUserActiveCourse(data)
    context.commit('USER_ACTIVE_COURSE_ADDED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const deleteFromUserActiveCourse = async (context, data) => {
  try {
    const response = await removeUserActiveCourse(data)
    context.commit('USER_ACTIVE_COURSE_REMOVED', response)
    context.dispatch(
      'app/setNotification',
      'The Course was removed from your active courses.',
      {
        root: true,
      }
    )
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const markVideoAsWatched = async (context, data) => {
  try {
    const response = await addUserWatchedVideo(data)
    context.commit('USER_MARKED_VIDEO_AS_WATCHED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const unmarkVideoAsWatched = async (context, data) => {
  try {
    const response = await removeUserWatchedVideo(data)
    context.commit('USER_UNMARKED_VIDEO_AS_WATCHED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const getUserPathProgress = async (context, data) => {
  try {
    const response = await fetchUserLearningPathProgress(data)
    context.commit('USER_PATH_PROGRESS_UPDATED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const getUserPathResume = async (context, data) => {
  try {
    const response = await fetchUserLearningPathResume(data)
    context.commit('USER_PATH_RESUME_UPDATED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const getUserActiveSubscriptions = async (context, memberId) => {
  try {
    const response = await fetchUserActiveSubscriptions(memberId)
    context.commit('USER_ACTIVE_SUBSCRIPTIONS', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const getSampleAvatars = async context => {
  try {
    const response = await fetchSampleAvatars()
    context.commit('USER_SAMPLE_AVATARS_UPDATED', response)
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

const updateUserAvatar = async (context, fileAndType) => {
  try {
    const response = await postUserAvatar(fileAndType)
    context.commit('USER_AVATAR_UPDATED', response.data.avatar)
    context.dispatch('app/setNotification', 'Avatar updated', {
      root: true,
    })
  } catch (error) {
    const { message } = error
    context.dispatch('app/setError', message, { root: true })
  }
}

export default {
  deleteBookmarkById,
  postUserVideoBookmark,
  getUserActiveCourses,
  postToUserActiveCourse,
  deleteFromUserActiveCourse,
  getBookmarksByCourse,
  storePendingUserBookmark,
  getAllUserCourseProgress,
  getUserCourseProgress,
  markVideoAsWatched,
  unmarkVideoAsWatched,
  getUserPathProgress,
  getUserPathResume,
  getUserActiveSubscriptions,
  getSampleAvatars,
  updateUserAvatar,
}
